
/** 直播状态 */
enum liveStatusEnum {
  NOT_START = '0',
  PLAYING = '1',
  COMPLETE = '2',
  PLAYING_BACK = '3',
  INVALID = '4',
}
enum liveRoomTypeenum {
  /** 直播 */
  LIVEING = '1',
  /** 回放 */
  REPLAY = '2'
}

const liveStatusName = {
  '0': '未开始',
  '1': '进行中',
  '2': '已结束',
  '3': '回放中',
  '4': '无效直播',
};
enum statCodeEnum {
 ALREADY_COMPLETE = '3',
 ALREADY_DELETE = '4'
}
enum userActionEnum {
  /** 用户加入直播, Group消息 */
  ENTER_LIVE = 1,
  /** 用户退出直播, Group消息 */
  EXIT_LIVE = 2,
  /** 点赞消息 */
  AVIMCMD_EXITLIVE = 3,
  /** 礼物消息 */
  AVIMCMD_GIFT = 6,
  /** 聊天消息, 包括管理员消息、主播消息、观众聊天消息、观众提问消息 */
  UPDATE_MESSAGE = 7,
  /** 直播结束 */
  THE_END = 8,
  /** 更新直播间相关信息 点赞，礼物，观众人数等 */
  UPDATE_LIVEROOM_INFO = 11,
  /** 红包来了 */
  RED_PACKET = 12,
  /** 积分红包来了 */
  RED_PACKET_POINT = 6803,
  /** 直播观看获得积分 */
  LIVE_GET_POINT = 6804,
  /** 下麦通知 */
  STOP_PLAY_NOTIFY  = 4103,
  /** 上麦通知 */
  START_PLAY_NOTIFY = 4102,
  /** 跟新麦序 */
  UPDATE_PLAY_NOTIFY = 4104,
  /** 开启签到 */
  SIGN_MSG = 4109,
  /** 成员进出通知 */
  MEMBER_IN_OUT_NOTIFY = 4112,
  /** 提问方式 */
  ASK_TYPE = 4561,
  /** 演示课件通知 */
  OPEN_COURSE_WARE = 6000,
  /** 结束课件通知 */
  CLOSE_COURSE_WARE = 6001,
  // 直播热词
  HOT_WORD_LIST = 6790,
  /** 推荐商品通知 */
  GOODS_MSG = 6100,
  /** 直播间敏感词 */
  ROOM_SENS_WORD = 6780,
  /** 分组讨论 */
  GROUP_DISCUSS = 6781,
  /** 流课件开始 */
  SHOW_STREAM_COURSE_WARE = 6783,
  /** 流课件结束 */
  END_STREAM_COURSE_WARE = 6784,
  /** 主播或助教更新图片直播 */
  PICTURE_LIVE_UPDATE = 6800,
  /** 表情消息 */
  EMOJI_MSG = 6801,
  /** 好车主自定义消息 */
  CAR_MSG = 9660,
  /** 考试 */
  EXAM_MSG = 4119,
  /** 考试红包 */
  EXAM_RED_PACKET = 4124,
  /** 中台更改直播间打赏、禁言、截屏分享开关 */
  ADMIN_CONTROLS = 6791,
  /** 主播推送问卷 */
  PUSH_QUESTIONNAIRE = 4113,
  /** 问卷后推送的红包 */
  PUSH_QUESTIONNAIRE_PACKET = 4123,
  /** 七牛SDK普通流变化信令 */
  QINIU_DEFAULT_STREAM = 6792,
  /** 七牛混流变化信令 */
  QINIU_MIX_STREAM = 6793,
  /** 好生活中奖信息 */
  HSH_LOTTERY = 101
}
/** 流状态 */
enum streamStatus{
  /** 开始推流 */
  START = 1,
  /** 停止推流 */
  SHUT = 2,
  /** 流异常中断 */
  INTERRUPT = 102,
  /* 停止拉所有流 */
  STOP_ALL = 110,
  /** 流（异常中断状态下）恢复正常 */
  CONTINUE = 103,
  /** 流（异常中断状态下）恢复正常 */
  MIX_REFRESH = 114,
  /* 停止拉混流 */
  MIX_STOP = 115
}
enum streamTypeEnum {
  /** 手机端摄像头的流 */
  MOBILE_CAMERA = 1001,
  /** pc端摄像头的流 */
  PC_CAERMA = 2001,
  /** pc端分享桌面(只有pc能分享桌面) */
  PC_SHARE_DES = 3001,
  /** pc端分享桌面(只有pc能分享窗口) */
  PC_SHARE_WINDOW = 4001,
  /** 摄像机流 */
  DIGITAL_VIDEO = 5001,
  /** pc端分享桌面(只有pc能分享窗口) */
  PC_MEDIA = 6001,
  /** zego混流 */
  MIX_STREAM = 7002,
  /** web端推流摄像头 */
  WEB_CAMERA = 8001,
  /** pc音频开播 */
  PC_AUDIO = 9011,
}
enum userActionMsgParam {
  // 普通聊天消息
  TALK_MESSAGE = 7,
  // 提问
  ASK = 8,
  /** 单个禁言 */
  SINGLE_FORBIDDEN = 9,
  // 禁言开关
  SHUT_UP_TOGGLE = 13,
  // 主播公告
  ACHOR_NOTICE = 20,
  // 助教公告
  HELP_ACHOR_NOTICE = 21,
  // 签到
  SIGN_IN = 18,
  // 举手信息
  HAND_MESSAGE = 16,
  // 系统消息
  SYSTEM_MESSAGE = 12,
  /** 取消禁言 */
  CANCEL_FORBIDDEN_MESSAGE = 6720,
}
// enum userActionParam {
//   /** 聊天消息, 包括管理员消息、主播消息、观众聊天消息、观众提问消息 */
//   TALK_MESSAGE = 7,
//   actionParam = 13
//   /** 更新直播间相关信息 点赞，礼物，观众人数等 */
//   UPDATE_LIVEROOM_INFO = 13,
// }
export {
  liveStatusEnum,
  liveStatusName,
  userActionEnum,
  userActionMsgParam,
  streamTypeEnum,
  statCodeEnum,
  liveRoomTypeenum,
  streamStatus
};
